import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Controller } from "@hotwired/stimulus";
import { Wrapper as QueryClientProvider } from "../helpers/queryClient";

const PersonalAccessTokensPage = lazy(
  () => import("../components/personalAccessTokens/PersonalAccessTokensPage"),
);

// Connects to data-controller="personal-access-tokens"
export default class extends Controller {
  // from devise/registrations/edit: [{name, label}] of the scopes a token may carry, and the
  // lifetimes in days to choose from
  static values = { scopes: Array, expiryDays: Array };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <QueryClientProvider>
        <Suspense fallback={null}>
          <PersonalAccessTokensPage
            scopes={this.scopesValue}
            expiryDays={this.expiryDaysValue}
          />
        </Suspense>
      </QueryClientProvider>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
